import './_faq-drawer.scss';

export default () => {};
